module.exports = __webpack_public_path__ + "img/img3.285d5fcf.svg";